import { Model } from '../context/product_context'
import { del, get, mountQuery, post, put } from './generic'

interface ModelApiData {
    idModelo: number
    nome: string
    idMarca: number
}

function ParseModel(data: ModelApiData): Model {
    return {
        id: data.idModelo,
        name: data.nome,
        markId: data.idMarca,
    }
}

export async function getModelsByMarkId(id_marca?: number): Promise<Model[]> {
    const query = mountQuery({ id_marca })

    const res = await get(`modelos?${query}`)
    return res.data.data.map((data: ModelApiData) => ParseModel(data))
}

export async function getModelById(id: number): Promise<Model> {
    const res = await get(`modelo/${id}`)
    return ParseModel(res.data.data.model)
}

export async function createModel(
    name: string,
    markId: number
): Promise<Model> {
    const res = await post(
        'modelo',
        {
            idMarca: markId,
            nome: name,
        },
        {
            useRecaptcha: true,
        }
    )
    return ParseModel(res.data.data.model)
}

export async function updateModel(
    id: number,
    name: string,
    markId: number
): Promise<void> {
    await put(
        'modelo',
        {
            id,
            idMarca: markId,
            nome: name,
        },
        {
            useRecaptcha: true,
        }
    )
}

export async function deleteModel(id: number): Promise<void> {
    await del(`modelo/${id}`, undefined, {
        useRecaptcha: true,
    })
}